import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '@core/errors/api-error';

export class NotFoundApiError extends ApiError {
  constructor(cause: HttpErrorResponse, body: unknown) {
    super('NotFoundApiError', cause, body);
  }
}
